<div class="flex flex-column gap-3">

  <div *ngIf="loading" class="flex align-items-center gap-2">
    <i class="pi pi-spin pi-spinner"></i>
    <span class="text-sm">Scanning folder contents&hellip;</span>
  </div>

  <ng-container *ngIf="!loading">

    <p *ngIf="options.length === 0 || options[0]?.count === 0" class="text-color-secondary text-sm m-0">
      No processible images were found in this folder.
    </p>

    <ng-container *ngIf="options.length > 0 && (options[0]?.count ?? 0) > 0">
      <p class="m-0 text-sm">
        This folder will be submitted as one run per image below. Choose which files to include:
      </p>

      <div class="flex flex-column gap-2">
        <div class="flex align-items-center gap-2" *ngFor="let option of options; let i = index">
          <p-radioButton
            [inputId]="'extension-option-' + i"
            name="extensionFilter"
            [value]="option.value"
            [(ngModel)]="selected">
          </p-radioButton>
          <label [for]="'extension-option-' + i">{{option.label}}</label>
        </div>

        <div class="flex align-items-center gap-2">
          <p-radioButton
            inputId="custom-regex-option"
            name="extensionFilter"
            [value]="customRegexOptionValue"
            [(ngModel)]="selected">
          </p-radioButton>
          <label for="custom-regex-option">Regular expression on file name</label>
        </div>

        <div class="flex flex-column gap-1 ml-4" *ngIf="selected === customRegexOptionValue">
          <input id="custom-regex-input" type="text" pInputText
                 class="p-inputtext-sm w-full"
                 [style.border-color]="customRegexHasError ? '#e24c4c' : null"
                 [(ngModel)]="customRegex"
                 name="customRegexInput"
                 placeholder="e.g. .*_4x\.ndpi"/>
          <span *ngIf="customRegexHasError" class="text-sm" style="color: red">
            Invalid regular expression.
          </span>
          <span *ngIf="!customRegex" class="text-color-secondary text-sm">
            Matched against the full filename (case-insensitive).
          </span>
        </div>
      </div>

      <p class="m-0 text-sm">
        This will submit <strong>{{selectedCount}}</strong> job<span *ngIf="selectedCount !== 1">s</span>.
      </p>
    </ng-container>
  </ng-container>

  <div class="flex justify-content-end gap-2">
    <button pButton type="button" label="Cancel" class="p-button-text" (click)="cancel()"></button>
    <button pButton type="button" label="Submit"
            [disabled]="loading || selectedCount === 0"
            (click)="confirm()"></button>
  </div>
</div>
